import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Heading, Icon, Link, Text } from 'bsd-react-ui-kit';

// constants
import { APP_PATHS } from 'routes/constants';

// selectors
import { getInviteToken } from 'modules/account/selectors';

export const GENERAL_ERROR_HEADING = 'Sorry, something went wrong';
export const GENERAL_ERROR_LINK_TEXT = 'try again';

export default function GeneralError({ hideRetry }) {
  const baseClass = 'bsd-general-error';
  const inviteToken = useSelector(getInviteToken);

  return (
    <div className={baseClass} role="alert">
      <div className={`${baseClass}-image`}>
        <Icon
          description="Alert Icon"
          modifier="error"
          name="circle-alert"
          size="xl"
        />
      </div>
      <div className={`${baseClass}-content`}>
        <Heading
          className={`${baseClass}-heading`}
          element="h1"
          modifier="bold"
          size="l"
        >
          {GENERAL_ERROR_HEADING}
        </Heading>
        <Text className={`${baseClass}-text`} element="p">
          Unable to load page. Please{' '}
          {!hideRetry ? (
            <Fragment>
              <Link
                modifier="anchor"
                search={`token=${inviteToken}`}
                to={APP_PATHS.enterZipCode}
              >
                {GENERAL_ERROR_LINK_TEXT}
              </Link>
              {' or '}
            </Fragment>
          ) : (
            ''
          )}
          contact us at{' '}
          <Link external modifier="anchor" to="tel:+18003913000">
            (800) 391-3000
          </Link>{' '}
          for assistance.
        </Text>
      </div>
    </div>
  );
}

GeneralError.propTypes = {
  hideRetry: PropTypes.bool,
};

GeneralError.defaultProps = {
  hideRetry: false,
};
